import * as ko from 'knockout'
import type ObservableRacePage from '../../../Model/Observables/ObservableRacePage'
import { BettingStateManagerViewModel } from './BettingStateManagerViewModel'
import { RaceDisplayStateManagerViewModel } from './RaceDisplayStateManagerViewModel'
import bettingStateTemplate from './bettingstate.tpl.html'
import raceDisplayStateTemplate from './race.display.state.tpl.html'

if (!ko.components.isRegistered('race-display-state')) {
  ko.components.register('race-display-state', {
    viewModel: {
      createViewModel: (params: {
        meetingId: string
        raceNumber: number
        meetingDate: Date
        raceStatus: string
      }) => {
        const viewModel = new RaceDisplayStateManagerViewModel(params)
        return viewModel
      },
    },
    template: raceDisplayStateTemplate,
  })
}

if (!ko.components.isRegistered('betting-state')) {
  ko.components.register('betting-state', {
    viewModel: {
      createViewModel: (params: { raceInformation: ObservableRacePage }) => {
        const viewModel = new BettingStateManagerViewModel(params)
        return viewModel
      },
    },
    template: bettingStateTemplate,
  })
}
